import { types, actions } from './requests'
export const UPLOADFILE_TYPES = {
    ...types('UPLOADFILE'),
}
export const UPLOADFILE_ACTIONS = {
    ...actions('UPLOADFILE'),
}
